var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFive3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50337 12.896H5.90475V20.7341C5.90475 21.8779 7.36734 22.4497 8.11564 21.5751L16.449 12.1896C17.4694 11.0459 17.0272 10.104 15.4966 10.104H12.0953V2.26589C12.0953 1.12214 10.6327 0.55026 9.88436 1.42489L1.55099 10.8104C0.530576 11.9541 0.972754 12.896 2.50337 12.896Z",
    stroke: "#BFFF00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive3);
export default __webpack_public_path__ + "static/media/five3.4dd18262a1d5fa0087ef1d4936389c54.svg";
export { ForwardRef as ReactComponent };